/**
 * Cart drawer S8 upsell:
 * - Upgrade button clears cart and adds S8 bundle variant.
 * - If S8 product exists in cart, remove all non-S8 items.
 */
(function () {
  const S8_PRODUCT_ID = "15329999028601";
  const S8_SUBSCRIPTION_SELLING_PLAN_ID = 712234467705;
  let enforcing = false;
  let upgrading = false;

  async function fetchCart() {
    const response = await fetch(`${window.routes.cart_url}.js`);
    return response.json();
  }

  async function enforceS8OnlyCart() {
    if (enforcing) return;

    let cart;
    try {
      cart = await fetchCart();
    } catch (error) {
      return;
    }

    const hasS8 = cart.items.some(
      (item) => String(item.product_id) === S8_PRODUCT_ID,
    );
    if (!hasS8) return;

    const hasOtherProducts = cart.items.some(
      (item) => String(item.product_id) !== S8_PRODUCT_ID,
    );
    if (!hasOtherProducts) return;

    enforcing = true;
    try {
      const updates = {};
      cart.items.forEach((item, index) => {
        if (String(item.product_id) !== S8_PRODUCT_ID) {
          const line = item.line != null ? item.line : index + 1;
          updates[String(line)] = 0;
        }
      });

      const response = await fetch(`${window.routes.cart_url}/update.js`, {
        ...fetchConfig(),
        body: JSON.stringify({ updates }),
      });
      if (!response.ok) return;

      document.dispatchEvent(
        new CustomEvent("cart-drawer:refresh", { bubbles: true }),
      );
      publish(PUB_SUB_EVENTS.cartUpdate, { source: "s8-package-enforce" });
    } catch (error) {
      console.error(error);
    } finally {
      enforcing = false;
    }
  }

  function scheduleEnforce() {
    window.setTimeout(enforceS8OnlyCart, 80);
  }

  document.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-s8-upgrade]");
    if (!button || upgrading) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    event.preventDefault();
    upgrading = true;
    button.disabled = true;
    button.classList.add("is-loading");

    try {
      const cartBeforeUpgrade = await fetchCart();
      const hasSubscriptionInCart = cartBeforeUpgrade.items.some(
        (item) => Boolean(item.selling_plan_allocation),
      );

      const clearResponse = await fetch(`${window.routes.cart_url}/clear.js`, {
        method: "POST",
        headers: { Accept: "application/json" },
      });
      if (!clearResponse.ok) return;

      const s8ItemPayload = { id: Number(variantId), quantity: 1 };
      if (hasSubscriptionInCart) {
        s8ItemPayload.selling_plan = S8_SUBSCRIPTION_SELLING_PLAN_ID;
      }

      const addResponse = await fetch(`${window.routes.cart_add_url}`, {
        ...fetchConfig(),
        body: JSON.stringify({
          items: [s8ItemPayload],
        }),
      });
      const addPayload = await addResponse.json();
      if (!addResponse.ok || addPayload.status) return;

      publish(PUB_SUB_EVENTS.cartUpdate, { source: "s8-package-upgrade" });
      document.dispatchEvent(
        new CustomEvent("cart-drawer:refresh", { bubbles: true }),
      );
    } catch (error) {
      console.error(error);
    } finally {
      upgrading = false;
      button.disabled = false;
      button.classList.remove("is-loading");
    }
  });

  if (typeof subscribe === "function") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.source === "s8-package-enforce") return;
      scheduleEnforce();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleEnforce);
  } else {
    scheduleEnforce();
  }
})();
